import { render, staticRenderFns } from "./UserEvents.vue?vue&type=template&id=0a9c95b2&scoped=true&"
import script from "./UserEvents.vue?vue&type=script&lang=js&"
export * from "./UserEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c95b2",
  null
  
)

export default component.exports